import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/lib/i18n";

/**
 * Compact language switcher — a globe icon + native-select of the 5 supported
 * languages. Persists the choice via localStorage (via i18next-browser-languagedetector).
 */
export function LanguageSwitcher({ className = "" }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  return (
    <label className={`inline-flex items-center gap-1.5 text-xs text-stone-600 ${className}`} data-testid="lang-switcher">
      <Globe className="h-3.5 w-3.5" aria-hidden />
      <span className="sr-only">{t("common.language")}</span>
      <select
        value={current}
        onChange={(e) => {
          // Mark this as an explicit user choice so QR-driven auto-switch
          // (see HotelProvider.applyLocale) respects the preference.
          localStorage.setItem("aura_lang_manual", "1");
          i18n.changeLanguage(e.target.value);
        }}
        className="bg-transparent border-none focus:outline-none cursor-pointer text-stone-700 font-medium"
        data-testid="lang-select"
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </label>
  );
}
